import React, { useEffect } from 'react';

import ReturnToMerchant from '../../shared/ReturnToMerchant';
import useRouteStatus from '../../../hooks/useRouteStatus';
import useSession from '../../../hooks/useSession';
import useSessionEntity from '../../../hooks/useSessionEntity';
import { declinedSupportPhone } from '../../../lib/constants/SiteVariables';
import { updateParent } from '../../../lib/utils/modal';

export default function Declined({ location }) {
  const [session, sessionActions] = useSession();
  const merchant = useSessionEntity('merchant');
  const cart = useSessionEntity('shopping_cart');

  const redirect = () => {
    if (session.mode === 'modal') {
      updateParent('complete', cart ? cart.cancel_url : '');
    } else {
      cart && session.session_type !== 'standalone'
        ? (window.location.href = cart.cancel_url)
        : (window.location.href = merchant.url);
    }
  };

  useRouteStatus(location);

  useEffect(() => {
    sessionActions.finish();
  }, []);

  return (
    <div id="content" className="text-center">
      <h2 className="text-xl my-2 text-navy-blue font-avenir-black">
        We're sorry, we are unable to approve your application.
      </h2>
      <div className="font-avenir-medium">
        You'll receive an email momentarily with further details, including how
        to address any concerns.
      </div>

      <div className="mt-2 mb-2">
        Any additional questions, please contact Credit Key support at{' '}
        <a href="mailto: support@creditkey.com">support@creditkey.com</a> or{' '}
        {declinedSupportPhone}.
      </div>

      <ReturnToMerchant merchant={merchant} redirect={redirect} />
    </div>
  );
}
